import { LastStateFromServer } from '../../../api';
import { ActualSchema, ACTUAL_VERSION, Schema, SCHEMAS, upVersion } from './index';
import { LastState } from '../model';

export function parse(lastStateFromServer: LastStateFromServer): LastState | undefined {
  // Смотрим, совпадает ли пришедший с сервера стейт с какой-либо схемой
  let state;
  const schemas = [...SCHEMAS];
  while (schemas.length) {
    const result = schemas.pop()?.safeParse(lastStateFromServer.state);
    if (result?.success) {
      state = result.data;
      break;
    }
  }

  if (!state) {
    // Ни одна схема не совпала
    return;
  }

  // Обновляем версию, пока она не станет актуальной
  while (state.version !== ACTUAL_VERSION) {
    const newState = upVersion(state);
    if (!newState) {
      break;
    }
    state = newState;
  }

  function isActualSchema(state: Schema): state is ActualSchema {
    return state.version === ACTUAL_VERSION;
  }

  // Если удалось обновить версию до актуальной, то возвращаем успешный результат
  if (isActualSchema(state)) {
    return { ...lastStateFromServer, state };
  }
}
